import React from 'react';
import cn from 'classnames';
import Image from 'next/legacy/image';
import { Button, Grid } from 'ht-styleguide';
import { noop } from '@utils/event';
import styles from '../locationPage.module.scss';

type MediaContentBlockTypes = {
  contentImage: string;
  secondaryImage?: string;
  titleText: string;
  buttonText?: string;
  locationDescriptions: React.ReactNode;
  onButtonClick: BaseAnyFunction;
  onImageClick: BaseAnyFunction;
};

const MediaContentBlock = ({
  contentImage,
  secondaryImage,
  titleText,
  locationDescriptions,
  buttonText,
  onButtonClick = noop,
  onImageClick = noop,
}: MediaContentBlockTypes) => {
  const handleClick = () => {
    onButtonClick();
  };

  return (
    <Grid.FullWidth classes={cn('paddingTop-huge1', styles.gridContainer)}>
      <Grid.Row classes={styles.customRow}>
        <Grid.Column sm={4} lg={6} classes={cn(styles.mediaImage, styles.contentBlockImage)}>
          <Image
            onClick={onImageClick}
            alt={titleText}
            quality={80}
            layout="responsive"
            width={100}
            height={80}
            objectFit="contain"
            objectPosition="top"
            src={contentImage}
          />
        </Grid.Column>
        <Grid.Column sm={4} mdOffset={1} md={6} lg={4} classes={styles.customColumn}>
          <h1 className="h3 n900 paddingBottom-medium">{titleText}</h1>
          {locationDescriptions}
          <Grid.Row classes="paddingTop-small2">
            <Grid.Column classes={styles.contentBlockColumnStyles} sm={4} mdOffset={2} md={4} lgOffset={0} lg={12}>
              <Button onClick={handleClick} className={styles.button}>
                {buttonText}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid.Column>
        {secondaryImage && (
          <Grid.Column sm={4} lg={6} classes={styles.secondaryImage}>
            <Image alt={titleText} quality={60} layout="responsive" width={100} height={10} src={secondaryImage} />
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid.FullWidth>
  );
};

export default MediaContentBlock;
